<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { onMounted, reactive } from 'vue'
import { Head } from '@inertiajs/inertia-vue3'
import Storecard from '@/Pages/Store/Storecard'
import Icon from '@/Shared/Icons/Logo'
import ButtonRounded from '@/Shared/Buttons/ButtonRounded'
import useFavorites from '@/Shared/useFavorites.js'
import usePref from '@/Shared/usePref.js'

const props = defineProps({
  stores: Object,
  areas: Object,
  pref: Object,
})

const favorite = reactive({
  favorites: [],
})

const filterShopbyArea = (areaID) => props.stores.filter((shop) => shop.states.area.areaID === areaID)

onMounted(() => {
  usePref(props.pref)
  const { sortFavoriteList, subscribeFavoriteList } = useFavorites({ favorite: favorite, category: 'shop' })
  sortFavoriteList()
  subscribeFavoriteList(sortFavoriteList)
})
</script>

<template>
  <div class="store-list">
    <Head title="A&amp;F Country一覧" />

    <div class="bg-white main-contents">
      <h2 class="page-title">
        Stores
        <small>A&amp;F店舗一覧</small>
      </h2>

      <div class="m-auto px-[calc(5vw_+_10px)] xs:px-[40px] sm:px-[60px] lg:px-0 max-w-[500px] sm:max-w-[900px]">
        <hr class="border-t border-dotted border-t-black" />

        <div class="md:flex items-center mt-[40px] mb-[60px]">
          <div class="md:w-[200px] mt-[20px] mb-[20px] md:mb-0 md:mr-[60px] lg:mr-[80px]"><Icon class="mx-auto my-[-50px] h-[200px] w-[200px] md:ml-[10px] lg:ml-[20px]" type="country" /></div>
          <div class="text-[13px] sm:text-[14px] leading-[1.8] grow [&>p]:mb-[0.5em]">
            <h4 class="text-[15px] sm:text-[16px] font-semibold mb-[0.5em]">A&amp;Fカントリー</h4>
            <p>A&amp;Fカントリーは、1977年に創業し、45年以上の歴史を持つアウトドア用品メーカー<br class="hidden lg:block" />㈱エイアンドエフの直営店です。</p>
            <p>世界のアウトドアブランドを販売しており、“良いものを永く”というコンセプトを基に商品を<br class="hidden lg:block" />品ぞろえしたアウトドアセレクトショップです。直営店舗は、北は北海道、南は九州まで、<br class="hidden lg:block" />全国に17店舗展開しております。</p>
            <p class="!mb-0">道具に精通したスタッフが店舗にて親切丁寧に皆様のアウトドアライフをサポートいたします。</p>
          </div>
        </div>

        <template v-if="favorite.favorites.length >= 1">
          <div class="area-container">
            <h3 class="area-title">
              <span>お気に入り</span>
            </h3>
            <div class="shop-container">
              <div v-for="shop in favorite.favorites" :key="shop.shopID">
                <Storecard :info="shop" />
              </div>
            </div>
          </div>
        </template>

        <div v-for="area in props.areas" :key="area.areaID" class="area-container">
          <template v-if="filterShopbyArea(area.areaID).length >= 1">
            <h3 class="area-title">
              <span>{{ area.areaNameLocal }}</span>
            </h3>
            <div class="shop-container">
              <div v-for="shop in filterShopbyArea(area.areaID)" :key="shop.shopID">
                <Storecard :info="shop" />
              </div>
            </div>
          </template>
        </div>

        <div class="area-container !mb-0">
          <h3 class="area-title">
            <span>オンライン</span>
          </h3>
          <div class="shop-container">
            <div><Storecard name="エイアンドエフ<br />オンラインストア" url="https://www.aandfstore.com/" icon="country" /></div>
            <div><Storecard name="A&amp;F COUNTRY<br />ZOZOTOWN店" url="https://zozo.jp/shop/aandfcountry/" icon="zozotown" /></div>
          </div>
        </div>
      </div>
      <div class="mt-[60px]">
        <ButtonRounded text="取り扱い店舗検索はこちら" icon="arrow" url="/stores/finder" class="!w-[250px] m-auto" />
      </div>
    </div>
  </div>
</template>
